// extracted by mini-css-extract-plugin
module.exports = {"MainApp":"MainApp_MainApp__1WiCc"};